import React from 'react';

import {TRANSLATIONS} from "../../../../constants/translation";
import {getLang} from "../../../../utils/common";

export const SuccessFailure=(props)=>{

    let {closePopup, afterPopupClose, message, success} = props,
        close=()=>{
            closePopup();
            afterPopupClose && afterPopupClose();
        },
        imageSrc = success ? '/images/registration_success.svg' : '/images/popquiz_wrong-02.svg'

    return (
        <div className='success-registration'>
            <img className="success-img" src={imageSrc} />
            {success && <h3>{TRANSLATIONS[getLang()].Resources.THANK_YOU}</h3>}
            <p>{message}</p>

            <a onClick={close} className='blue-link'>DONE</a>
        </div>
    )
}

SuccessFailure.defaultProps = {
    success: true
};